import { Component } from '@angular/core';

import { DashboardSystemComponent } from './dashboard-system.component';

@Component({
  selector: 'app-dashboard-system-developer',
  standalone: true,
  imports: [DashboardSystemComponent],
  template: `
    <app-dashboard-system
      [dashboardLayout]="'SYSTEM_DEVELOPER'"
      [pageTitle]="'Platform developer'"
      [pageSubtitle]="'Integrations, entities, and technical health'"
    />
  `,
})
export class DashboardSystemDeveloperComponent {}
